<template>
  <div class="products">
    <div class="banner" :style="{ background: 'linear-gradient(120deg, #E0EAF4, #B5C8DC)' }">
      <div class="container">
        <div class="banner-content">
          <h1>产品与服务</h1>
          <p>我们提供一站式的教育信息化解决方案，助力教育机构数字化转型</p>
        </div>
      </div>
    </div>

    <div class="section">
      <div class="container">
        <el-tabs v-model="activeTab" @tab-click="handleTabClick" class="product-tabs">
          <el-tab-pane label="教育局数据赋能" name="bureau"></el-tab-pane>
          <el-tab-pane label="智慧校园解决方案" name="school"></el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <div v-if="activeTab === 'bureau'" class="section product-content-section" style="background-color: #f8f9fa;">
      <div class="container">
        <h2 class="product-title">教育局数据赋能</h2>

        <!-- 分类导航 -->
        <div class="category-nav">
          <el-radio-group v-model="activeBureauCategory" @change="handleCategoryChange">
            <el-radio-button label="all">全部</el-radio-button>
            <el-radio-button label="finance">财务管理</el-radio-button>
            <el-radio-button label="hr">人事管理</el-radio-button>
            <el-radio-button label="student">学生服务</el-radio-button>
            <el-radio-button label="office">办公管理</el-radio-button>
            <el-radio-button label="resource">资源管理</el-radio-button>
            <el-radio-button label="data">数据分析</el-radio-button>
          </el-radio-group>
        </div>

        <!-- 分类标题 -->
        <h3 v-if="activeBureauCategory !== 'all'" class="category-title">
          {{ getCategoryTitle(activeBureauCategory) }}
        </h3>

        <div class="product-grid">
          <div
            class="product-item"
            v-for="(product, index) in filteredBureauProducts"
            :key="index"
          >
            <el-card
              class="product-card"
              shadow="hover"
              @click.native="handleProductClick(product)"
              :id="'product-' + product.type"
              :class="{'highlighted-product': highlightedProduct === product.type}"
            >
              <div class="product-header" :style="{ backgroundColor: product.color }">
                <i :class="product.icon"></i>
                <h3>{{ product.title }}</h3>
              </div>
              <div class="product-body">
                <p class="product-desc">{{ product.shortDesc }}</p>
                <ul class="feature-list">
                  <li v-for="(feature, i) in product.features.slice(0, 3)" :key="i">
                    <i class="el-icon-check"></i> {{ feature }}
                  </li>
                </ul>
                <div class="product-action">
                  <el-button type="primary" size="small" @click.stop="handleProductClick(product)">查看详情</el-button>
                </div>
              </div>
            </el-card>
          </div>
        </div>
      </div>
    </div>

    <div v-if="activeTab === 'school'" class="section product-content-section" style="background-color: #f0f7ff;">
      <div class="container">
        <h2 class="product-title">智慧校园解决方案</h2>

        <!-- 分类导航 -->
        <div class="category-nav">
          <el-radio-group v-model="activeSchoolCategory" @change="handleCategoryChange">
            <el-radio-button label="all">全部</el-radio-button>
            <el-radio-button label="teacher">教师管理</el-radio-button>
            <el-radio-button label="school-student">学生管理</el-radio-button>
            <el-radio-button label="teaching">教学管理</el-radio-button>
            <el-radio-button label="service">校园服务</el-radio-button>
            <el-radio-button label="admin">行政管理</el-radio-button>
          </el-radio-group>
        </div>

        <!-- 分类标题 -->
        <h3 v-if="activeSchoolCategory !== 'all'" class="category-title">
          {{ getCategoryTitle(activeSchoolCategory) }}
        </h3>

        <div class="product-grid">
          <div
            class="product-item"
            v-for="(product, index) in filteredSchoolProducts"
            :key="index"
          >
            <el-card
              class="product-card"
              shadow="hover"
              @click.native="handleProductClick(product)"
              :id="'product-' + product.type"
              :class="{'highlighted-product': highlightedProduct === product.type}"
            >
              <div class="product-header" :style="{ backgroundColor: product.color }">
                <i :class="product.icon"></i>
                <h3>{{ product.title }}</h3>
              </div>
              <div class="product-body">
                <p class="product-desc">{{ product.shortDesc }}</p>
                <ul class="feature-list">
                  <li v-for="(feature, i) in product.features.slice(0, 3)" :key="i">
                    <i class="el-icon-check"></i> {{ feature }}
                  </li>
                </ul>
                <div class="product-action">
                  <el-button type="primary" size="small" @click.stop="handleProductClick(product)">查看详情</el-button>
                </div>
              </div>
            </el-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Products',
  data() {
    return {
      activeTab: 'bureau',
      activeBureauCategory: 'all', // 当前选中的教育局产品分类
      activeSchoolCategory: 'all', // 当前选中的学校产品分类
      selectedType: '',
      highlightedProduct: null, // 添加高亮产品的标识
      // 产品分类映射
      categoryMap: {
        // 教育局产品分类
        'finance': ['budget', 'asset', 'audit'],
        'hr': ['hr'],
        'student': ['after-school', 'student-aid'],
        'office': ['project-application', 'document-system'],
        'resource': ['literature-cloud', 'equipment-transfer'],
        'data': ['big-data'],
        // 学校产品分类
        'teacher': ['teacher', 'open-class'],
        'school-student': ['activity', 'badge', 'evaluation', 'mentor'],
        'teaching': ['grade', 'homework', 'course-selection', 'course-management'],
        'service': ['shop', 'campus-circle', 'e-class-sign', 'food-order'],
        'admin': ['attendance', 'meeting', 'salary', 'oa']
      },
      // 分类标题映射
      categoryTitles: {
        'finance': '财务管理',
        'hr': '人事管理',
        'student': '学生服务',
        'office': '办公管理',
        'resource': '资源管理',
        'data': '数据分析',
        'teacher': '教师管理',
        'school-student': '学生管理',
        'teaching': '教学管理',
        'service': '校园服务',
        'admin': '行政管理'
      },
      // ... 保留原有的产品数据
      bureauProducts: [
        {
          title: '预算系统',
          type: 'budget',
          shortDesc: '专业智能的教育预算管理系统，提高资金使用效率',
          description: '预算系统是专为教育局打造的智能财务预算管理平台，实现教育经费全流程管理，帮助教育部门优化资源分配，提高资金使用效率，实现精准透明的教育经费管理。',
          icon: 'el-icon-money',
          color: '#4A85C9',
          features: [
            '预算编制与审核',
            '预算执行与监控',
            '资金分配管理',
            '财务报表分析',
            '预警与提醒',
            '多级审批流程'
          ],
          advantages: [
            {
              title: '精准预算',
              desc: '基于历史数据和AI算法，提供精准预算建议，合理分配教育资源'
            },
            {
              title: '全流程管理',
              desc: '覆盖预算申请、审批、执行、分析全流程，无缝衔接，提高工作效率'
            },
            {
              title: '数据可视化',
              desc: '直观展示预算执行情况，帮助管理层快速决策'
            }
          ],
          cases: [
            {
              name: '上海市静安区区教育局',
              desc: '通过我们的预算系统，该教育局实现了预算编制时间缩短40%，预算执行率提高20%'
            }
          ]
        },
        {
          title: '资产系统',
          type: 'asset',
          shortDesc: '教育资产全生命周期管理，提高资产利用率',
          description: '资产系统是专为教育局设计的资产管理平台，实现教育资产全生命周期管理，从采购、入库、使用到报废，全程可追溯，提高资产使用效率，降低资产流失风险。',
          icon: 'el-icon-s-grid',
          color: '#5E97D5',
          features: [
            '资产台账管理',
            '资产采购管理',
            '资产调拨与借用',
            '资产维修与保养',
            '资产盘点与报废',
            '二维码资产标签'
          ],
          advantages: [
            {
              title: '全生命周期',
              desc: '覆盖资产从采购到报废的全过程，实现全程可视化管理'
            },
            {
              title: '移动管理',
              desc: '支持手机APP扫码操作，便捷进行资产盘点、借用等操作'
            },
            {
              title: '数据分析',
              desc: '通过大数据分析，优化资产配置，提高资产使用效率'
            }
          ],
          cases: [
            {
              name: '上海市某教育局',
              desc: '使用我们的资产系统后，该教育局资产利用率提升25%，资产流失率降低80%'
            }
          ]
        },
        {
          title: '人力资源系统',
          type: 'hr',
          shortDesc: '教师人事统筹管理，优化人力资源配置',
          description: '人力资源系统是专为教育局设计的教师队伍管理平台，实现教师信息、考核、晋升、培训等全方位管理，助力教育部门优化人力资源配置，提高教师队伍建设水平。',
          icon: 'el-icon-user',
          color: '#3376BC',
          features: [
            '教师信息管理',
            '职称评定管理',
            '考核奖惩管理',
            '教师培训管理',
            '调动与交流管理',
            '统计分析报表'
          ],
          advantages: [
            {
              title: '精准画像',
              desc: '构建教师专业画像，精准了解每位教师的专业发展状况'
            },
            {
              title: '流程优化',
              desc: '简化人事管理流程，减少行政负担，提高工作效率'
            },
            {
              title: '科学决策',
              desc: '基于数据分析，为教师队伍建设提供科学决策支持'
            }
          ],
          cases: [
            {
              name: '上海市静安区教育局',
              desc: '通过使用我们的人力资源系统，该区教师考核时间缩短，教师满意度提高'
            }
          ]
        },
        {
          title: '内审系统',
          type: 'audit',
          shortDesc: '规范内部审计流程，提高财务管理透明度',
          description: '内审系统是专为教育局设计的内部审计管理平台，通过信息化手段规范审计流程，提高审计效率和质量，增强财务管理透明度和合规性，为教育部门决策提供数据支持。',
          icon: 'el-icon-document-checked',
          color: '#4C8BCD',
          features: [
            '审计计划管理',
            '审计项目执行',
            '审计报告生成',
            '问题整改跟踪',
            '审计档案管理',
            '风险预警分析'
          ],
          advantages: [
            {
              title: '规范流程',
              desc: '标准化审计流程，确保审计工作规范、高效进行'
            },
            {
              title: '智能分析',
              desc: '运用大数据技术，智能识别异常数据，提高审计效率'
            },
            {
              title: '闭环管理',
              desc: '从审计计划到整改落实形成闭环，确保审计成果有效应用'
            }
          ],
          cases: [
            {
              name: '江苏省某教育局',
              desc: '通过内审系统的应用，该教育局审计效率提升40%，财务合规性显著提高'
            }
          ]
        },
        {
          title: '三段式课后服务系统',
          type: 'after-school',
          shortDesc: '一站式管理课后服务，提升学生课后时间利用效率',
          description: '三段式课后服务系统是专为教育局打造的课后服务管理平台，实现对辖区内学校课后服务的统一规划、管理和评估，提供丰富多样的课后活动资源，提升学生课后时间利用效率。',
          icon: 'el-icon-time',
          color: '#5795D3',
          features: [
            '课后服务规划',
            '活动资源库',
            '师资调配管理',
            '学生报名选课',
            '考勤与评价',
            '数据统计分析'
          ],
          advantages: [
            {
              title: '三段式设计',
              desc: '根据学生需求，分为作业辅导、特色活动、自主学习三个阶段，满足不同学生需求'
            },
            {
              title: '资源整合',
              desc: '整合区域内优质教育资源，为学校提供丰富的课后服务内容'
            },
            {
              title: '数据驱动',
              desc: '通过数据分析，不断优化课后服务内容和形式，提高服务质量'
            }
          ],
          cases: [
            {
              name: '深圳市某区教育局',
              desc: '实施三段式课后服务系统后，区域内学生参与率达95%，家长满意度提升至92%'
            }
          ]
        },
        {
          title: '学生资助系统',
          type: 'student-aid',
          shortDesc: '精准管理学生资助项目，确保资助公平有效',
          description: '学生资助系统是专为教育局设计的资助管理平台，实现对各类资助项目的全流程管理，确保资助资金精准发放，帮助家庭经济困难学生顺利完成学业。',
          icon: 'el-icon-coin',
          color: '#4A85C9',
          features: [
            '资助项目管理',
            '学生信息审核',
            '资金发放管理',
            '资助评估反馈',
            '统计报表分析',
            '政策宣传公示'
          ],
          advantages: [
            {
              title: '精准识别',
              desc: '多维度评估学生家庭经济状况，确保资助精准到位'
            },
            {
              title: '全程透明',
              desc: '资助全过程公开透明，接受社会监督，确保公平公正'
            },
            {
              title: '效果跟踪',
              desc: '跟踪资助效果，形成资助育人良性循环'
            }
          ],
          cases: [
            {
              name: '河南省某教育局',
              desc: '通过学生资助系统，该区资助准确率达99%，资金使用效率提高35%'
            }
          ]
        },
        {
          title: '项目申报',
          type: 'project-application',
          shortDesc: '简化项目申报流程，提高审批效率和透明度',
          description: '项目申报系统是专为教育局打造的项目管理平台，简化教育项目的申报、审批、执行和评估流程，提高项目管理效率和透明度，促进教育资源优化配置。',
          icon: 'el-icon-s-order',
          color: '#3E78BD',
          features: [
            '项目申报管理',
            '在线评审流程',
            '项目执行跟踪',
            '资金使用监控',
            '项目成果展示',
            '绩效评估分析'
          ],
          advantages: [
            {
              title: '流程简化',
              desc: '优化项目申报流程，减少纸质材料，提高申报效率'
            },
            {
              title: '在线评审',
              desc: '专家在线评审，提高评审效率和公正性'
            },
            {
              title: '全程监控',
              desc: '项目执行全程监控，确保项目按计划推进，资金合理使用'
            }
          ],
          cases: [
            {
              name: '浙江省某教育局',
              desc: '实施项目申报系统后，项目审批时间缩短60%，项目执行效率提升40%'
            }
          ]
        },
        {
          title: '文件收发系统',
          type: 'document-system',
          shortDesc: '高效管理文件流转，提升行政办公效率',
          description: '文件收发系统是专为教育局设计的文件管理平台，实现教育系统内部文件的电子化收发、流转和归档，提高行政办公效率，降低纸质文件使用量，推动办公无纸化。',
          icon: 'el-icon-document',
          color: '#4C8BCD',
          features: [
            '文件收发管理',
            '流程自动化',
            '文件追踪查询',
            '在线阅读批注',
            '文件归档管理',
            '统计分析报表'
          ],
          advantages: [
            {
              title: '高效流转',
              desc: '文件电子化流转，实时掌握文件处理状态，提高办公效率'
            },
            {
              title: '安全可靠',
              desc: '多重安全机制保障文件安全，权限精细化管理'
            },
            {
              title: '智能归档',
              desc: '文件智能分类归档，便于后续查询和使用'
            }
          ],
          cases: [
            {
              name: '上海市静安区教育局',
              desc: '使用文件收发系统后，文件处理效率得到提高，纸张使用量减少'
            }
          ]
        },
        {
          title: '智慧文献数据云系统',
          type: 'literature-cloud',
          shortDesc: '集中管理教育文献资源，便捷检索和共享',
          description: '智慧文献数据云系统是专为教育局打造的文献资源管理平台，整合各类教育文献资源，提供智能检索、在线阅读、资源共享等功能，为教育工作者提供知识支持。',
          icon: 'el-icon-reading',
          color: '#286FB5',
          features: [
            '文献资源管理',
            '智能检索系统',
            '在线阅读标注',
            '资源共享协作',
            '个性化推荐',
            '使用数据分析'
          ],
          advantages: [
            {
              title: '资源整合',
              desc: '整合各类教育文献资源，形成统一的知识库'
            },
            {
              title: '智能检索',
              desc: '基于AI的智能检索技术，快速定位所需资源'
            },
            {
              title: '知识共享',
              desc: '促进教育系统内部知识共享与协作，提升整体教研水平'
            }
          ],
          cases: [
            {
              name: '上海市某教育局',
              desc: '通过智慧文献系统，该区教师资源获取效率提升65%，教研质量显著提高'
            }
          ]
        },
        {
          title: '设备调拨台账系统',
          type: 'equipment-transfer',
          shortDesc: '精确管理设备调拨，提高资源利用效率',
          description: '设备调拨台账系统是专为教育局设计的设备管理平台，实现教育设备的调拨、分配和使用全过程管理，提高教育设备利用率，实现资源优化配置。',
          icon: 'el-icon-s-cooperation',
          color: '#6A9DD8',
          features: [
            '设备信息管理',
            '调拨申请审批',
            '设备流转跟踪',
            '使用情况记录',
            '维修保养管理',
            '统计分析报表'
          ],
          advantages: [
            {
              title: '精准调配',
              desc: '根据学校需求和设备状况，实现设备精准调配'
            },
            {
              title: '全程可溯',
              desc: '设备调拨全过程可追溯，确保资产安全'
            },
            {
              title: '数据驱动',
              desc: '通过数据分析，优化设备配置，提高资源利用效率'
            }
          ],
          cases: [
            {
              name: '广东省某教育局',
              desc: '实施设备调拨系统后，设备利用率提高45%，闲置设备减少60%'
            }
          ]
        },
        {
          title: '教育局大数据系统',
          type: 'big-data',
          shortDesc: '多维度收集和分析教育数据，辅助决策和规划',
          description: '教育局大数据系统是专为教育局打造的数据分析平台，整合各类教育数据，通过大数据分析技术，为教育决策和规划提供数据支持，促进教育质量提升和均衡发展。',
          icon: 'el-icon-data-analysis',
          color: '#3376BC',
          features: [
            '数据采集整合',
            '多维数据分析',
            '可视化展示',
            '预测模型构建',
            '决策支持系统',
            '教育质量评估'
          ],
          advantages: [
            {
              title: '多维分析',
              desc: '整合学生、教师、学校等多维数据，系统化分析教育现状'
            },
            {
              title: '科学决策',
              desc: '基于数据分析结果，为教育决策提供科学依据'
            },
            {
              title: '精准规划',
              desc: '根据发展趋势预测，制定精准的教育发展规划'
            }
          ],
          cases: [
            {
              name: '江苏省某教育局',
              desc: '通过大数据系统应用，该区教育资源配置更加合理，区域教育质量提升22%'
            }
          ]
        }
      ],
      schoolProducts: [
        {
          title: '成绩分析系统',
          type: 'grade',
          shortDesc: '智能化的学生成绩分析平台',
          description: '成绩分析系统是专为学校打造的智能分析工具，通过对学生考试成绩进行多维度分析，帮助教师精准了解学生学习情况，为个性化教学提供数据支持。',
          icon: 'el-icon-s-data',
          color: '#286FB5',
          features: [
            '成绩录入与管理',
            '班级成绩分析',
            '学生个人分析',
            '学科等第评价',
            '学情诊断报告',
            '成绩趋势分析'
          ],
          advantages: [
            {
              title: '多维深度的分析洞察',
              desc: '从年级、班级、个人等多个维度分析成绩，精准掌握学情'
            },
            {
              title: '个性化的学习诊断',
              desc: '基于学生的学习轨迹与成绩表现，为每个学生生成专属的学习诊断报告'
            },
            {
              title: '便捷的教学管理辅助',
              desc: '教师可利用平台轻松进行班级成绩管理，为学校教学管理提供客观依据'
            }
          ],
          cases: [
            {
              name: '上海市某中学',
              desc: '使用我们的成绩分析系统，该校平均成绩提升15%，学生学习积极性明显提高'
            }
          ]
        },
        {
          title: '教师在线学习平台',
          type: 'teacher',
          shortDesc: '专业教师培训学习平台，促进教师成长',
          description: '教师在线学习平台是专为学校打造的教师专业发展平台，提供丰富的在线课程、教研活动和学习资源，助力教师持续成长，提升教育教学水平。',
          icon: 'el-icon-reading',
          color: '#2A5EA1',
          features: [
            '在线课程学习',
            '教研活动管理',
            '学习资源库',
            '学习进度跟踪',
            '互动交流社区',
            '培训证书管理'
          ],
          advantages: [
            {
              title: '丰富资源',
              desc: '整合优质教育培训资源，提供多样化学习内容'
            },
            {
              title: '个性化学习',
              desc: '根据教师需求和发展方向，推荐个性化学习路径'
            },
            {
              title: '社群互动',
              desc: '建立教师学习社群，促进教师间交流分享和协作'
            }
          ],
          cases: [
            {
              name: '上海市某重点中学',
              desc: '使用我们的在线学习平台，教师教学能力得到显著提升'
            }
          ]
        },
        {
          title: '学生活动平台',
          type: 'activity',
          shortDesc: '丰富多彩的学生活动管理平台',
          description: '学生活动平台是专为学校设计的活动管理系统，实现学生活动的全流程管理，包括活动策划、报名、执行、评价等环节，丰富校园文化生活，助力学生多元成长。',
          icon: 'el-icon-data-board',
          color: '#5795D3',
          features: [
            '活动发布与宣传',
            '在线报名管理',
            '活动考勤记录',
            '活动照片墙',
            '活动评价反馈',
            '活动数据分析'
          ],
          advantages: [
            {
              title: '全流程管理',
              desc: '覆盖活动策划、宣传、报名、执行全过程，提高活动管理效率'
            },
            {
              title: '互动体验',
              desc: '提供丰富的互动功能，增强学生参与感和活动体验'
            },
            {
              title: '成长记录',
              desc: '记录学生活动参与情况，形成个人成长档案'
            }
          ],
          cases: [
            {
              name: '上海市某实验学校',
              desc: '通过我们的活动平台，该校学生活动参与率提高40%，学生满意度达95%'
            }
          ]
        },
        {
          title: '学生争章平台',
          type: 'badge',
          shortDesc: '激励学生成长的荣誉体系平台',
          description: '学生争章平台是一套完整的学生激励系统，通过设立多种成长徽章，激励学生在德智体美劳各方面均衡发展，形成积极向上的校园文化氛围。',
          icon: 'el-icon-medal',
          color: '#3E78BD',
          features: [
            '徽章体系设计',
            '徽章申请与审核',
            '徽章展示墙',
            '成长记录档案',
            '学生排行榜',
            '家长查看通道'
          ],
          advantages: [
            {
              title: '多元激励',
              desc: '覆盖学习、体育、艺术、社会实践等多个领域，助力学生多元成长'
            },
            {
              title: '阶梯成长',
              desc: '设置不同级别徽章，引导学生逐步提升能力'
            },
            {
              title: '可视化展示',
              desc: '直观展示学生成长轨迹，增强成就感和自信心'
            }
          ],
          cases: [
            {
              name: '深圳市某小学',
              desc: '实施我们的争章平台后，学生自主学习积极性提高45%，综合素质明显提升'
            }
          ]
        },
        {
          title: '学生评价系统',
          type: 'evaluation',
          shortDesc: '多维的学生素质发展评价系统',
          description: '学生评价系统是面向素质教育的综合评价工具，通过多元化评价方式，系统化记录和评价学生发展情况，促进学生个性化、多元化成长。',
          icon: 'el-icon-s-claim',
          color: '#6A9DD8',
          features: [
            '多元评价指标',
            '学生自评互评',
            '教师评价管理',
            '家长参与评价',
            '成长档案生成',
            '评价分析报告'
          ],
          advantages: [
            {
              title: '多维评价',
              desc: '覆盖品德、学业、身心、艺术、劳动等多个维度，促进多元发展'
            },
            {
              title: '多方参与',
              desc: '整合学生自评、教师评价、家长评价等多方视角，形成立体评价'
            },
            {
              title: '发展性评价',
              desc: '关注学生成长过程和进步幅度，激励持续发展'
            }
          ],
          cases: [
            {
              name: '杭州市某实验学校',
              desc: '实施我们的评价系统后，学生综合素质评价更加系统客观，家校协同育人效果显著提升'
            }
          ]
        },
        {
          title: '在线商城',
          type: 'shop',
          shortDesc: '便捷的校园教育资源购买平台',
          description: '在线商城是为学校提供的数字化购物平台，方便师生购买教辅资料、学习用品、校园周边等产品，同时支持学校自营教育资源的在线销售。',
          icon: 'el-icon-shopping-cart-full',
          color: '#4C8BCD',
          features: [
            '商品管理展示',
            '在线支付结算',
            '订单处理追踪',
            '积分与优惠',
            '评价与反馈',
            '数据统计分析'
          ],
          advantages: [
            {
              title: '便捷购买',
              desc: '一站式购买教育资源，节省时间，提高效率'
            },
            {
              title: '资源整合',
              desc: '整合优质教育产品和服务，为师生提供更多选择'
            },
            {
              title: '个性推荐',
              desc: '基于用户画像，推荐个性化学习资源和产品'
            }
          ],
          cases: [
            {
              name: '上海市某学校',
              desc: '通过我们的在线商城，该学校联盟实现了教育资源共享，大幅降低了采购成本'
            }
          ]
        },
        {
          title: '回家作业平台',
          type: 'homework',
          shortDesc: '智能管理学生作业，提高教学效率和学习效果',
          description: '回家作业平台是专为学校打造的作业管理系统，实现作业布置、提交、批改、反馈的全流程管理，提高教师作业管理效率，增强学生学习效果。',
          icon: 'el-icon-notebook-1',
          color: '#3376BC',
          features: [
            '作业在线布置',
            '智能题库推荐',
            '在线提交批改',
            '作业数据分析',
            '错题收集管理',
            '家长查看反馈'
          ],
          advantages: [
            {
              title: '智能推荐',
              desc: '基于学生学习情况，智能推荐个性化作业内容'
            },
            {
              title: '高效批改',
              desc: '支持自动批改与教师在线批改，大幅提高批改效率'
            },
            {
              title: '数据分析',
              desc: '分析作业完成情况，精准把握学生学习状态'
            }
          ],
          cases: [
            {
              name: '上海市某中学',
              desc: '使用回家作业平台后，教师批改时间减少，学生作业完成质量得到提升'
            }
          ]
        },
        {
          title: '选课平台',
          type: 'course-selection',
          shortDesc: '灵活的选课系统，满足个性化学习需求',
          description: '选课平台是专为学校设计的课程选择系统，支持学生根据兴趣和发展需求自主选择课程，实现个性化学习路径，支持学生个性发展。',
          icon: 'el-icon-s-management',
          color: '#4A85C9',
          features: [
            '课程信息管理',
            '在线选课系统',
            '智能推荐功能',
            '课程评价反馈',
            '学分管理系统',
            '数据统计分析'
          ],
          advantages: [
            {
              title: '丰富选择',
              desc: '提供多样化课程选择，满足不同学生的发展需求'
            },
            {
              title: '智能匹配',
              desc: '基于学生兴趣和能力，智能推荐适合的课程'
            },
            {
              title: '高效管理',
              desc: '简化选课流程，提高课程管理效率'
            }
          ],
          cases: [
            {
              name: '上海市某实验中学',
              desc: '实施选课平台后，学生选课满意度达92%，课程多样性增加45%'
            }
          ]
        },
        {
          title: '全员导师平台',
          type: 'mentor',
          shortDesc: '构建师生互动平台，促进个性化指导和成长',
          description: '全员导师平台是专为学校打造的师生互动系统，实现"一对一"或"一对多"的导师制管理，促进教师对学生的个性化指导，助力学生个性化成长。',
          icon: 'el-icon-user-solid',
          color: '#286FB5',
          features: [
            '导师分配管理',
            '成长目标设定',
            '定期交流记录',
            '成长档案管理',
            '评价反馈系统',
            '数据分析报表'
          ],
          advantages: [
            {
              title: '个性化指导',
              desc: '根据学生特点提供个性化指导，促进学生多元发展'
            },
            {
              title: '系统化管理',
              desc: '规范导师工作流程，提高导师工作效率和质量'
            },
            {
              title: '全程记录',
              desc: '记录学生成长全过程，形成完整成长档案'
            }
          ],
          cases: [
            {
              name: '浙江省某中学',
              desc: '通过全员导师平台，该校学生问题解决率提高65%，师生关系显著改善'
            }
          ]
        },
        {
          title: '校园圈',
          type: 'campus-circle',
          shortDesc: '构建校园社交网络，促进师生交流与信息共享',
          description: '校园圈是专为学校打造的社交平台，为师生提供安全、健康的交流空间，促进校园信息共享、文化传播和情感交流，增强校园凝聚力。',
          icon: 'el-icon-chat-dot-round',
          color: '#5E97D5',
          features: [
            '动态发布分享',
            '兴趣圈子管理',
            '校园活动宣传',
            '即时通讯功能',
            '内容审核机制',
            '数据统计分析'
          ],
          advantages: [
            {
              title: '安全可控',
              desc: '封闭式校园社交环境，内容审核机制，确保平台健康发展'
            },
            {
              title: '促进交流',
              desc: '打破班级和年级界限，促进校园内部广泛交流'
            },
            {
              title: '文化传播',
              desc: '传播校园文化，增强师生归属感和认同感'
            }
          ],
          cases: [
            {
              name: '广东省某中学',
              desc: '实施校园圈后，校园活动参与度提升50%，师生互动频率增加80%'
            }
          ]
        },
        {
          title: '电子班牌',
          type: 'e-class-sign',
          shortDesc: '智能电子班牌系统，展示班级风采和信息',
          description: '电子班牌系统是专为学校设计的智能显示终端，实时展示班级信息、学校通知、教学安排等内容，提升校园信息化水平，展示班级特色风采。',
          icon: 'el-icon-monitor',
          color: '#6A9DD8',
          features: [
            '班级信息展示',
            '课表实时更新',
            '通知公告发布',
            '班级风采展示',
            '互动签到功能',
            '远程管理控制'
          ],
          advantages: [
            {
              title: '信息实时',
              desc: '实时更新班级信息和学校通知，提高信息传递效率'
            },
            {
              title: '特色展示',
              desc: '展示班级特色和学生风采，增强班级凝聚力'
            },
            {
              title: '智能管理',
              desc: '支持远程管理和内容更新，提高管理效率'
            }
          ],
          cases: [
            {
              name: '江苏省某实验学校',
              desc: '使用电子班牌系统后，学校信息传达效率提高75%，班级特色文化建设显著增强'
            }
          ]
        },
        {
          title: '课务系统',
          type: 'course-management',
          shortDesc: '高效管理课程安排，优化教学资源配置',
          description: '课务系统是专为学校打造的课程管理平台，实现课程安排、教室分配、教师调度等全方位管理，优化教学资源配置，提高课务管理效率。',
          icon: 'el-icon-date',
          color: '#4C8BCD',
          features: [
            '课表编排管理',
            '教室资源分配',
            '教师课时统计',
            '调课换课处理',
            '课程冲突检测',
            '数据统计分析'
          ],
          advantages: [
            {
              title: '智能排课',
              desc: '基于多种约束条件，智能生成最优课表方案'
            },
            {
              title: '资源优化',
              desc: '合理分配教室和教师资源，提高资源利用效率'
            },
            {
              title: '便捷管理',
              desc: '简化调课换课流程，提高课务管理效率'
            }
          ],
          cases: [
            {
              name: '山东省某重点中学',
              desc: '使用课务系统后，该校排课时间缩短80%，教室利用率提高30%'
            }
          ]
        },
        {
          title: '师生考勤系统',
          type: 'attendance',
          shortDesc: '智能考勤管理，提高校园管理效率',
          description: '师生考勤系统是专为学校设计的考勤管理平台，通过多种考勤方式，实现对师生出勤情况的实时记录和分析，提高考勤管理效率，促进校园规范化管理。',
          icon: 'el-icon-alarm-clock',
          color: '#2A5EA1',
          features: [
            '多种考勤方式',
            '实时考勤记录',
            '异常考勤提醒',
            '请假审批流程',
            '考勤统计分析',
            '家长查询通道'
          ],
          advantages: [
            {
              title: '智能识别',
              desc: '支持人脸识别、指纹识别等多种考勤方式，提高考勤准确性'
            },
            {
              title: '实时监控',
              desc: '实时记录考勤情况，异常情况及时提醒'
            },
            {
              title: '数据分析',
              desc: '多维度分析考勤数据，为学校管理提供决策支持'
            }
          ],
          cases: [
            {
              name: '福建省某学校',
              desc: '实施考勤系统后，该校学生出勤率提高15%，考勤管理时间减少70%'
            }
          ]
        },
        {
          title: '会议系统',
          type: 'meeting',
          shortDesc: '便捷的会议预约和管理，提高沟通效率',
          description: '会议系统是专为学校打造的会议管理平台，实现会议室预约、会议通知、会议纪要等全流程管理，提高会议效率，促进校内沟通协作。',
          icon: 'el-icon-s-flag',
          color: '#286FB5',
          features: [
            '会议室预约',
            '会议通知发送',
            '签到与考勤',
            '会议纪要管理',
            '会议资料共享',
            '统计分析报表'
          ],
          advantages: [
            {
              title: '便捷预约',
              desc: '简化会议室预约流程，避免资源冲突'
            },
            {
              title: '高效通知',
              desc: '自动发送会议通知，提醒参会人员'
            },
            {
              title: '资料共享',
              desc: '会议资料在线共享，促进信息传递和沟通'
            }
          ],
          cases: [
            {
              name: '上海市某学校',
              desc: '使用会议系统后，校会议准时率得到提高，会议效率提升'
            }
          ]
        },
        {
          title: '工资系统',
          type: 'salary',
          shortDesc: '精确计算和管理教职工薪资，提高人事管理效率',
          description: '工资系统是专为学校设计的薪资管理平台，实现教职工薪资的精确计算、发放和查询，提高薪资管理透明度和效率，减轻人事管理负担。',
          icon: 'el-icon-wallet',
          color: '#3E78BD',
          features: [
            '薪资结构设置',
            '绩效考核管理',
            '薪资自动计算',
            '工资条生成',
            '薪资查询统计',
            '税费自动处理'
          ],
          advantages: [
            {
              title: '精确计算',
              desc: '根据薪资结构和考核结果，精确计算每位教职工薪资'
            },
            {
              title: '透明管理',
              desc: '薪资构成透明化，教职工可随时查询薪资明细'
            },
            {
              title: '高效处理',
              desc: '自动化薪资计算和发放流程，提高人事管理效率'
            }
          ],
          cases: [
            {
              name: '上海市某学校',
              desc: '使用工资系统后，该校薪资处理时间减少85%，薪资计算准确率达99.9%'
            }
          ]
        },
        {
          title: '公开课管理平台',
          type: 'open-class',
          shortDesc: '系统化管理公开课资源，促进教学交流与提升',
          description: '公开课管理平台是专为学校打造的教学展示与交流系统，实现公开课的申请、审批、观摩、评价全流程管理，促进教师间教学经验交流和教学水平提升。',
          icon: 'el-icon-video-camera',
          color: '#286FB5',
          features: [
            '公开课申请审批',
            '课程资料管理',
            '观课预约系统',
            '课堂实况录制',
            '教学评价反馈',
            '优质课例收藏'
          ],
          advantages: [
            {
              title: '资源共享',
              desc: '收集整理优质公开课资源，促进教学经验共享'
            },
            {
              title: '便捷管理',
              desc: '简化公开课申请和观摩流程，提高管理效率'
            },
            {
              title: '促进提升',
              desc: '通过同行评价和反馈，促进教师教学水平提升'
            }
          ],
          cases: [
            {
              name: '浙江省某教育集团',
              desc: '使用公开课平台后，该集团教师参与公开课次数增加60%，教学质量显著提升'
            }
          ]
        },
        {
          title: '师生订餐系统',
          type: 'food-order',
          shortDesc: '便捷的校园订餐服务，提升师生用餐体验',
          description: '师生订餐系统是专为学校打造的餐饮服务平台，实现在线菜单查看、餐食预订、支付结算等功能，提高食堂管理效率，改善师生用餐体验。',
          icon: 'el-icon-food',
          color: '#4C8BCD',
          features: [
            '在线菜单管理',
            '餐食预订点餐',
            '在线支付结算',
            '取餐提醒通知',
            '用餐评价反馈',
            '数据统计分析'
          ],
          advantages: [
            {
              title: '便捷订餐',
              desc: '随时随地在线订餐，避免排队等待'
            },
            {
              title: '精准备餐',
              desc: '根据预订数据，精准备餐，减少浪费'
            },
            {
              title: '个性推荐',
              desc: '基于用餐习惯，推荐个性化餐食选择'
            }
          ],
          cases: [
            {
              name: '广东省某学校',
              desc: '使用订餐系统后，该校食堂排队时间减少70%，餐食满意度提升40%'
            }
          ]
        },
        {
          title: 'OA办公系统',
          type: 'oa',
          shortDesc: '一站式校园办公自动化系统，提高行政效率',
          description: 'OA办公系统是专为学校打造的综合办公平台，整合工作安排、文印系统、陪餐记录、请假、采购、报修等多种功能，实现校园行政办公自动化，提高管理效率。',
          icon: 'el-icon-office-building',
          color: '#0077B6',
          features: [
            '工作安排管理',
            '文印申请审批',
            '陪餐记录管理',
            '请假流程管理',
            '物品采购申请',
            '设备报修处理'
          ],
          advantages: [
            {
              title: '流程优化',
              desc: '优化各类行政办公流程，提高工作效率'
            },
            {
              title: '系统集成',
              desc: '整合多种办公功能，实现一站式办公'
            },
            {
              title: '数据共享',
              desc: '各模块数据互通共享，避免重复工作'
            }
          ],
          cases: [
            {
              name: '江苏省某学校',
              desc: '使用OA系统后，该校行政办公效率提高50%，师生满意度提升45%'
            }
          ]
        }
      ]
    }
  },
  computed: {
    // 根据分类筛选教育局产品
    filteredBureauProducts() {
      if (this.activeBureauCategory === 'all') {
        return this.bureauProducts;
      } else {
        const productTypes = this.categoryMap[this.activeBureauCategory] || [];
        return this.bureauProducts.filter(product => productTypes.includes(product.type));
      }
    },
    // 根据分类筛选学校产品
    filteredSchoolProducts() {
      if (this.activeSchoolCategory === 'all') {
        return this.schoolProducts;
      } else {
        const productTypes = this.categoryMap[this.activeSchoolCategory] || [];
        return this.schoolProducts.filter(product => productTypes.includes(product.type));
      }
    }
  },
  created() {
    // 从URL参数初始化页面状态
    this.initFromUrlParams();
  },
  watch: {
    // 监听路由变化，当URL参数改变时重新初始化页面状态
    '$route'() {
      this.initFromUrlParams();
    }
  },
  methods: {
    // 获取分类标题
    getCategoryTitle(category) {
      return this.categoryTitles[category] || '';
    },
    // 从URL参数初始化页面状态
    initFromUrlParams() {
      const query = this.$route.query;

      // 设置当前标签页
      if (query.tab && (query.tab === 'bureau' || query.tab === 'school')) {
        this.activeTab = query.tab;
      }

      // 设置当前分类
      if (query.category) {
        const category = query.category;
        if (this.activeTab === 'bureau') {
          this.activeBureauCategory = category;
        } else {
          this.activeSchoolCategory = category;
        }
      } else {
        // 如果没有category参数，重置为"全部"
        if (this.activeTab === 'bureau') {
          this.activeBureauCategory = 'all';
        } else {
          this.activeSchoolCategory = 'all';
        }
      }

      // 处理type参数，定位到具体产品
      if (query.type) {
        const productType = query.type;
        this.highlightedProduct = productType;

        // 确定产品所属的标签页和分类
        let foundInBureau = false;
        let foundInSchool = false;
        let category = 'all';

        // 查找产品所属分类
        Object.keys(this.categoryMap).forEach(cat => {
          if (this.categoryMap[cat].includes(productType)) {
            category = cat;

            // 判断是教育局还是学校产品
            if (['finance', 'hr', 'student', 'office', 'resource', 'data'].includes(cat)) {
              foundInBureau = true;
              this.activeTab = 'bureau';
              this.activeBureauCategory = category;
            } else {
              foundInSchool = true;
              this.activeTab = 'school';
              this.activeSchoolCategory = category;
            }
          }
        });

        // 如果没有找到分类，则尝试在所有产品中查找
        if (!foundInBureau && !foundInSchool) {
          // 在教育局产品中查找
          const bureauProduct = this.bureauProducts.find(p => p.type === productType);
          if (bureauProduct) {
            this.activeTab = 'bureau';
          } else {
            // 在学校产品中查找
            this.activeTab = 'school';
          }
        }

        // 滚动到产品位置
        this.$nextTick(() => {
          setTimeout(() => {
            const element = document.getElementById('product-' + productType);
            if (element) {
              element.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          }, 300); // 延迟执行，确保DOM已更新
        });
      } else {
        // 如果没有type参数，清除高亮
        this.highlightedProduct = null;
      }
    },
    // 处理标签页切换
    handleTabClick() {
      // 更新URL参数
      this.$router.replace({
        path: '/products',
        query: {
          tab: this.activeTab,
          ...(this.activeTab === 'bureau' && this.activeBureauCategory !== 'all' ? { category: this.activeBureauCategory } : {}),
          ...(this.activeTab === 'school' && this.activeSchoolCategory !== 'all' ? { category: this.activeSchoolCategory } : {})
        }
      });
    },
    // 处理分类切换
    handleCategoryChange() {
      // 更新URL参数
      this.$router.replace({
        path: '/products',
        query: {
          tab: this.activeTab,
          ...(this.activeTab === 'bureau' && this.activeBureauCategory !== 'all' ? { category: this.activeBureauCategory } : {}),
          ...(this.activeTab === 'school' && this.activeSchoolCategory !== 'all' ? { category: this.activeSchoolCategory } : {})
        }
      });
    },
    // 处理产品点击
    handleProductClick(product) {
      // 在新窗口中打开产品详情页面
      const routeData = this.$router.resolve({
        path: '/product-detail',
        query: { type: product.type }
      });
      window.open(routeData.href, '_blank');
    }
  }
}
</script>

<style scoped>
.banner {
  padding: 70px 0;
  color: #2C3E50;
  margin-bottom: 40px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  position: relative;
}
.banner-content {
  text-align: center;
  position: relative;
  z-index: 2;
}
.banner-content h1 {
  font-size: 2.8rem;
  margin-bottom: 1rem;
  font-weight: 600;
}
.banner-content p {
  font-size: 1.3rem;
  max-width: 600px;
  margin: 0 auto;
  font-weight: 300;
}

.product-title {
  margin: 40px 0 30px;
  text-align: center;
  color: #333;
  font-size: 1.8rem;
}

.product-row {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -15px;
}

.product-col {
  padding: 15px;
  display: flex;
}

.product-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 30px;
  margin-bottom: 40px;
}

.product-item {
  display: flex;
  flex-direction: column;
}

.product-card {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 350px;
  margin-bottom: 20px;
  transition: all 0.3s ease;
  cursor: pointer;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  overflow: hidden;
  position: relative;
}

.product-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 30px rgba(25, 118, 210, 0.1);
  border-color: rgba(25, 118, 210, 0.2);
}

.product-card:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 5px;
  height: 0;
  background-color: #1976D2;
  transition: height 0.3s ease;
}

.product-card:hover:before {
  height: 100%;
}

.product-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 20px;
}

.product-action {
  margin-top: auto;
  text-align: center;
}

.product-header {
  padding: 20px;
  color: white;
  text-align: center;
  position: relative;
  transition: all 0.3s ease;
}

.product-header i {
  font-size: 2.8rem;
  margin-bottom: 15px;
  display: block;
  transition: transform 0.3s ease;
}

.product-card:hover .product-header i {
  transform: scale(1.15);
}

.product-header h3 {
  font-size: 1.3rem;
  margin: 0;
  font-weight: 600;
}

.product-desc {
  color: #555;
  margin-bottom: 15px;
  min-height: 50px;
  line-height: 1.5;
  font-size: 1rem;
}

.feature-list {
  list-style: none;
  padding: 0;
  margin-bottom: 20px;
  flex: 1;
  min-height: 90px;
}

.feature-list li {
  margin-bottom: 10px;
  color: #555;
  display: flex;
  align-items: flex-start;
  font-size: 0.95rem;
}

.feature-list i {
  color: #67C23A;
  margin-right: 8px;
  margin-top: 3px;
  flex-shrink: 0;
}

.product-action .el-button {
  transition: all 0.3s ease;
  font-weight: 500;
  padding: 8px 15px;
  width: 100%;
}

.product-action .el-button:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 15px rgba(25, 118, 210, 0.2);
}

/* 响应式优化 */
@media (max-width: 991px) {
  .product-grid {
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 20px;
  }

  .product-card {
    min-height: 380px;
  }
}

@media (max-width: 767px) {
  .product-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .product-card {
    min-height: auto;
  }

  .product-desc {
    min-height: auto;
  }

  .product-header h3 {
    font-size: 1.3rem;
  }

  .banner-content h1 {
    font-size: 2rem;
  }

  .banner-content p {
    font-size: 1rem;
  }
}

/* 添加高亮产品的样式 */
.highlighted-product {
  transform: translateY(-5px);
  box-shadow: 0 15px 30px rgba(25, 118, 210, 0.2);
  border: 2px solid #1976D2;
}

.highlighted-product:before {
  height: 100%;
}

/* 添加滚动平滑效果 */
html {
  scroll-behavior: smooth;
}

/* 添加分类导航样式 */
.category-nav {
  margin: 20px 0 30px;
  text-align: center;
}

.category-title {
  margin: 0 0 30px;
  text-align: center;
  font-size: 1.5rem;
  color: #1976D2;
}

/* 产品列表布局样式 */
.product-tabs {
  margin-bottom: 0;
}

.product-content-section {
  padding-top: 20px;
}

.product-title {
  font-size: 1.8rem;
  color: #2C3E50;
  margin-bottom: 20px;
  position: relative;
  padding-bottom: 15px;
  text-align: center;
}

.product-title:after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 3px;
  background-color: #1976D2;
}

.product-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 25px;
  margin-bottom: 40px;
}

.product-item {
  display: flex;
  flex-direction: column;
}
</style>
